@if (showUpcomingSection()) {
  <section class="block" aria-labelledby="upcoming-recurring-title">
    <div class="flex items-center justify-between gap-4 px-upcoming-title-inline pt-px">
      <h2
        id="upcoming-recurring-title"
        class="m-0 text-upcoming-pill font-extrabold uppercase leading-none tracking-upcoming-title text-text-muted"
      >
        Upcoming
      </h2>
      <a
        class="upcoming-recurring-view-all text-xs font-extrabold text-brand-primary-strong hover:underline focus-visible:rounded-sm focus-visible:outline-none focus-visible:shadow-focus"
        routerLink="/recurring-transactions"
        >View all</a
      >
    </div>

    <div
      class="-mx-[14px] mt-[6px] flex snap-x snap-proximity scroll-pl-[14px] gap-[10px] overflow-x-auto px-[14px] py-[2px] [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
    >
      @for (card of upcomingCards(); track card.id) {
        <article
          class="w-[196px] shrink-0 snap-start rounded-[12px] border border-[var(--app-border-default)] bg-surface-elevated px-[12px] py-[10px]"
        >
          <div class="flex items-baseline justify-between gap-[8px]">
            <h3 class="m-0 min-w-0 truncate text-[13px] font-extrabold leading-[17px] text-text-title">
              {{ card.title }}
            </h3>
            @if (amountLabel(card) !== null) {
              <p
                class="m-0 shrink-0 text-[13px] font-black leading-[17px] tabular-nums"
                [class.text-status-success]="isIncome(card)"
                [class.text-text-title]="!isIncome(card)"
              >
                {{ amountLabel(card) }}
              </p>
            }
          </div>
          <p class="m-0 mt-[3px] text-upcoming-pill font-medium leading-[15px] text-text-muted">
            {{ card.expectedDate | date: 'MMM d' }} ·
            <span
              [class]="
                isToday(card)
                  ? 'rounded-full bg-surface-recurring-expense-pill px-[6px] py-px font-extrabold text-text-recurring-expense-pill'
                  : ''
              "
              >{{ expectedInLabel(card) }}</span
            >
          </p>
        </article>
      }
    </div>
  </section>
}
